export const BUILTIN_NOTE_TYPE_LABELS: Record<string, string> = {
  Consultation: "Consultation Note",
  "Phone Call": "Phone Call",
  "Follow Up": "Follow-up Visit",
  Markings: "Markings",
};

export const getNoteTypeDisplayName = (t: string) =>
  BUILTIN_NOTE_TYPE_LABELS[t] ?? t;
